import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface DonationOrgInfo {
  legalName: string;
  ein?: string | null;
  email?: string | null;
  verified?: boolean;
  extraLine?: string | null;
}

@Component({
    selector: 'don-footer',
    imports: [CommonModule, TranslateModule],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() org: DonationOrgInfo = {
    legalName: 'Crezco Foundation Inc',
    ein: '921100986',
    email: 'info@crezcofoundation.org',
    verified: true,
  };
}
